import axios from 'axios'
import Router from '../router/index'
import {Toast} from 'vant'

const axiosInstance = axios.create({
  baseURL: window.g.URL,
  // responseType: 'json',
  timeout: 50000
})

var count = 0

function startToast() {
  Toast.loading({
    duration: 0,
    overlay: true,
    message: '',
    loadingType: 'spinner'
  })
  count++
}

function endToast() {
  count--
  if (count === 0) {
    Toast.clear()
  }
}

// 发送请求前处理
axiosInstance.interceptors.request.use((config) => {
  if (!config.isHidden) {
    startToast()
  }
  config.headers['Accept'] = 'Content-Type:application/json'
  config.headers['Content-Type'] = 'application/json'
  // console.log(config)
  return config
}, (error) => {
  return Promise.reject(error)
})

// 接受返回后，回调之前处理处理
axiosInstance.interceptors.response.use((res) => {
  if (!res.config.isHidden) {
    endToast()
  }
  if (res.data.result == 2) {
    // Toast.clear()
    // endToast()
    return
  } else if (res.data.result == 1) {
    res.data.resultNote ? Toast(res.data.resultNote) : ''
  } else {
    // endToast()
    // Toast.clear()
  }
  return res.data
}, err => {
  if (!err.config.isHidden) {
    endToast()
  }
  // Toast.clear()
  Toast('服务器开小差了')
  return Promise.reject(err)
})

export function get(params, url) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: 'get',
      url: url || '/service?json=' + JSON.stringify(params)
    }).then(res => {
      resolve(res)
    })
      .catch(err => {
        reject(err)
      })
  })
}

export function fetch(params, url, ischeck, isHidden) {
  if (ischeck) {
    //判断调用这个接口是否需要登陆，判断是否登陆
    if (!localStorage.getItem('uid')) {
      localStorage.setItem('beforeUrl', Router.currentRoute.fullPath)
      Toast('请先登录')
      count = 0
      Toast.clear()
      Router.push('/user/login')//是否登陆是否注册
      return false
    }
  }
  let promise = new Promise((resolve, reject) => {
    axiosInstance({
      method: 'post',
      url,
      data: params,
      isHidden: isHidden
    }).then(res => {
      resolve(res)
    })
      .catch(err => {
        reject(err)
      })
  })
  return promise
}



// WEBPACK FOOTER //
// ./src/config/axios.js